import { IonIcon, IonInput, IonLabel } from '@ionic/react'
import { HeatingType } from '@vae/server/dist/client'
import React, { Fragment, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { ObjectContext } from '../../contexts/objectContext/ObjectContext'
import { trpc } from '../../modules/trpc'
import { HeatingSlideStateType } from '../types/types'
import { heatingOptions } from './OnboardingTypeOptions'

interface Props {
	onInteraction: () => void
	state: [HeatingSlideStateType, React.Dispatch<React.SetStateAction<HeatingSlideStateType>>]
}

const HeatingTypeSlide: React.FC<Props> = ({ onInteraction, state }) => {
	const object = useContext(ObjectContext)

	const { t, i18n } = useTranslation('pages_onboarding')

	const { mutate: updateObject } = trpc.objects.edit.useMutation({
		onSuccess: () => {
			onInteraction()
		},
	})

	const validHeatingTypes: HeatingType[] = [
		'district',
		'geothermal',
		'electric',
		'timedElectric',
		'oil',
		'wood',
		'airWaterHeatPump',
	]

	const handleOptionClick = async (optionValue: string) => {
		if (validHeatingTypes.includes(optionValue as HeatingType)) {
			state[1](state => {
				return { ...state, selected: optionValue }
			})
			await updateObject({
				id: object?.id as number,
				data: {
					heatingType: optionValue as HeatingType,
				},
			})
		}

		if (!optionValue.includes('lectr')) {
			onInteraction()
		}
	}

	if (!object) return null

	return (
		<>
			<h1 className='text-text-dark dark:text-white'>{t('heatingTypeSlide.millainenLammitys')}</h1>
			<div className='options-container'>
				{heatingOptions(i18n.language as 'fi' | 'en').map(option => (
					<Fragment key={option.value}>
						<div
							onClick={() => handleOptionClick(option.value)}
							className={`option border border-brand-primary-100-light dark:border-brand-primary-100-dark${
								state[0].selected === option.value
									? ' bg-brand-secondary-200-light dark:bg-surface-dark'
									: ' hover'
							}`}
						>
							<IonIcon
								className='text-brand-primary-100-light dark:text-brand-primary-100-dark'
								icon={option.icon}
							/>
							<IonLabel className='text-text-dark dark:text-white'>{option.label}</IonLabel>
						</div>
						{state[0].selected === option.value && (
							<div className='squares-question text-text-dark dark:text-white'>
								<span>{t('heatingTypeSlide.lammitettavaPintaAla')}</span>
								<div className='input-container'>
									<IonInput
										type='number'
										value={state[0].squares}
										className='border-brand-primary-100-light dark:border-brand-primary-100-dark'
										onIonInput={e => {
											const value = e.detail.value as string

											updateObject({
												id: object?.id as number,
												data: {
													squares: parseFloat(value),
												},
											})
											state[1](state => {
												return { ...state, squares: value }
											})
										}}
									/>
									<span className='unit dark:text-brand-primary-100-dark'>
										m<sup>2</sup>
									</span>
								</div>
							</div>
						)}
					</Fragment>
				))}
			</div>
		</>
	)
}

export default HeatingTypeSlide
